import React from 'react'
import styles from './CreateBalance.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import SelectCustom from '../../../Select/SelectCustom'

const CreateBalance = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <div className={styles.groupForm}>
      <FormField>
        <FormLabel isRequired>Select company:</FormLabel>
        <SelectCustom
          placeholder={'Select company'}
          apiLink='db/companies'
          valueID={modalValue.company}
          onChange={(o) => changeValues(o.id, 'company')}
          error={check('company')}
          isSearchable
          error={check('company')}
        />
      </FormField>
    </div>
  )
}

export default observer(CreateBalance)
